import {ResolvedPos} from "prosemirror-model";
import {schema} from "../../module/config/schema";

export const getNearestCellPos = ($pos: ResolvedPos): ResolvedPos | null => {
    for (let d = 1; d <= $pos.depth; d++) {
        const node = $pos.node(-d);
        if (node && node.type === schema.nodes.tableDataCell) {
            return $pos.doc.resolve($pos.before(-d)); // Use `before` to resolve the position before the cell
        }
    }
    return null;
}